export const types = {
    products:
        [
            'roleManagement',
            'tradingViewChart',
            'technicalAnalysis',
            'fundamentalAnalysis',
            'onChainAnalysis',
            'heatMap',
            'setup',
            'notification',
            'usersProfile',
            'winRate',
            'imbalance',
            'vmc',
            'coins'
        ],
    actions: [
        'create',
        'delete',
        'update',
        'read',
        'readall'
    ]
}